import api, { prepareQueryParameters } from "@/store/api";
import {Params, TimeFilter, Trade, TradeDetail, Transaction, TransactionDetail} from "@/types";
import { getDateRange } from "../helpers";

interface TradeDetails {
	[key: number]: TradeDetail;
}

interface TransactionDetails {
	[key: number]: TransactionDetail;
}

export enum TransactionTypeFilter {
	ALL = '',
	CREDIT = 1,
	DEBIT = 0
}

const [from, to] = getDateRange(TimeFilter.YEAR);
const emptyState = () => {
	return {
		loading: false,
		loadingList: false,
		loadingNext: false,
		transactions: [] as Transaction[],
		dashboardTransactions: [],
		conversions: [],
		trades: [] as Trade[],
		from,
		to,
		transactionDetails: {} as TransactionDetails,
		tradeDetails: {} as TradeDetails,
		transactionsTypeFilter: TransactionTypeFilter.ALL,
		transactionsValueFilter: {
			from: null,
			to: null
		},
	}
};

const state = emptyState();
type State = typeof state;

interface TransactionParams extends Params {
	page: number;
	append: boolean;
	investmentStrategyId: number;
	from?: Date;
	to?: Date;
	valueFrom?: number;
	valueTo?: number;
}

export default {
	namespaced: true,
	state: emptyState(),
	getters: {},
	actions: {
		dashboardTransactions(store: any, params: TransactionParams) {
			// store.commit("setLoading", true);
			api
				.get(`transactions/latest-transactions/`)
				.then(({data}) => {
					store.commit("setDashboardTransactions", { data: data.result });
					// store.commit("setLoading", false);
				})
				.catch((error) => {
					store.commit("setDashboardTransactions", { data: [] });
					// store.commit("setLoading", false);
				});
		},
		transactions(store: any, params: TransactionParams) {
			// params.page === 1 ? store.commit("setLoadingList", true) : store.commit("setLoadingNext", true);
			const append = params.append || false;
			api
				.get(`transactions/transactions?${prepareQueryParameters(params)}`)//prepareQueryParameters
				.then(({data}) => {
					store.commit("setTransactions", { data: data.result, append });
					// params.page === 1 ? store.commit("setLoadingList", false) : store.commit("setLoadingNext", false);
				})
				.catch((error) => {
					store.commit("setTransactions", { data: [], append });
					// store.commit("setLoading", false);
				});
		},
		transactionDetail(store: any, { id, date, index }: { id: string; date: Date; index: number }) {
			if (!store.state.transactionDetails.hasOwnProperty(id)) {
				api
					.get(`transactions/transactionDetail?id=${id}`)
					.then(({data}) => {
						store.commit("setTransactionDetail", { id, detail: data.result, index });
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		trades(store: any, params: TransactionParams) {
			// params.page === 1 ? store.commit("setLoading", true) : store.commit("setLoadingNext", true);
			const append = params.append || false;
			api
				.get(`transactions/trades?${prepareQueryParameters(params)}`)
				.then(({data}) => {
					store.commit("setTrades", { data: data.result, append });
					// params.page === 1 ? store.commit("setLoading", false) : store.commit("setLoadingNext", false);
				})
				.catch((error) => {
					store.commit("setTrades", []);
					// store.commit("setLoading", false);
				});
		},
		tradeDetail(store: any, { id, index }: { id: string; index: number }) {
			if (!store.state.transactionDetails.hasOwnProperty(id)) {
				api
					.get(`transactions/tradeDetail?id=${id}`)
					.then(({data}) => {
						store.commit("setTradeDetail", { id, detail: data.result, index });
					})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		conversions(store: any, params: TransactionParams) {
			// params.page === 1 ? store.commit("setLoading", true) : store.commit("setLoadingNext", true);
			const append = params.append || false;
			api
				.get(`transactions/conversions?${prepareQueryParameters(params)}`)
				.then(({data}) => {
					store.commit("setConversions", { data: data.result, append });
					// params.page === 1 ? store.commit("setLoading", false) : store.commit("setLoadingNext", false);
				})
				.catch((error) => {
					store.commit("setConversions", []);
					// store.commit("setLoading", false);
				});
		},
	},
	mutations: {
		resetTransactions(state: State) {
			state.transactions = [];
		},
		setTransactions(state: State, data: any) {
			state.transactions = data.append ? [...state.transactions, ...data.data] : data.data;
		},
		setDashboardTransactions(state: State, data: any) {
			state.dashboardTransactions = data.data;
		},
		setConversions(state: State, data: any) {
			state.conversions = data.append ? [...state.conversions, ...data.data] : data.data;
		},
		setLoading(state: State, data: boolean) {
			state.loading = data;
		},
		setLoadingList(state: State, data: boolean) {
			state.loadingList = data;
		},
		setLoadingNext(state: State, data: boolean) {
			state.loadingNext = data;
		},
		setTrades(state: State, data: any) {
			state.trades = data.append ? [...state.trades, ...data.data] : data.data;
		},
		setTransactionDetail(state: State, { id, detail, index }: { id: number; detail: TransactionDetail; index: number }) {
			state.transactionDetails = { ...state.transactionDetails, [id]: detail };
			const transactions = state.transactions;
			transactions[index].detail = detail;
			state.transactions = [...transactions];
		},
		setTradeDetail(state: State, { id, detail, index }: { id: number; detail: TradeDetail; index: number }) {
			state.tradeDetails = { ...state.tradeDetails, [id]: detail };
			const trades = state.trades;
			trades[index].detail = detail;
			state.trades = [...trades];
		},
		resetTransactionDetails(state: State) {
			state.transactionDetails = {} as TransactionDetails;
		},
		resetTradeDetails(state: State) {
			state.tradeDetails = {} as TradeDetails;
		},
		reset (state: any) {
			Object.assign(state, emptyState());
		}
	},
};
